import {Box} from "@mui/material";

export default function EasterEggPage() {
    return (
        <Box sx={{mt: 3}}>
            I found the easter egg page and all I got was this lousy text
        </Box>
    );
}